import {
    ObjectGroup,
    TiersObjectGroup,
    useSociete,
    useTiersService,
} from '@europrocurement/l2d-domain';
import {
    ObjectGroupApiCreateObjectGroupObjectGroupCollectionRequest,
    ObjectGroupApiDeleteObjectGroupObjectGroupItemRequest,
    ObjectGroupApiPatchObjectGroupObjectGroupItemRequest,
    ObjectGroupApiSearchObjectGroupByTypeObjectGroupCollectionRequest,
    ObjectGroupJsonldObjectgroupCreate,
    ObjectGroupJsonldObjectgroupUpdate,
} from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { ObjectGroupColor, ObjectGroupType } from '@europrocurement/flexy-components';

const useSocietesObjectGroup = () => {
    const { objectGroupApi } = useTiersService();
    let searchObjectGroupTimeout: number | undefined;
    const xIdSociete = useSociete();

    const searchTiersObjectGroup = (label: string): Promise<Array<TiersObjectGroup>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchObjectGroupTimeout);
            let requestParameters: ObjectGroupApiSearchObjectGroupByTypeObjectGroupCollectionRequest =
                { type: 'sousClient', label };
            if (xIdSociete !== null) {
                requestParameters = { xIdSociete, ...requestParameters };
            }

            searchObjectGroupTimeout = setTimeout(() => {
                objectGroupApi
                    .searchObjectGroupByTypeObjectGroupCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<TiersObjectGroup>))
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
        });

    const editTiersObjectGroup = (
        objectGroup: ObjectGroupType,
    ): Promise<ObjectGroupJsonldObjectgroupUpdate> =>
        new Promise((resolve, reject) => {
            let requestParameter: ObjectGroupApiPatchObjectGroupObjectGroupItemRequest = {
                id: objectGroup.id.toString(),
                objectGroupObjectgroupUpdate: {
                    label: objectGroup.label,
                    color: objectGroup.color,
                    iconName: objectGroup.icone,
                },
            };
            if (xIdSociete !== null) {
                requestParameter = { xIdSociete, ...requestParameter };
            }
            objectGroupApi
                .patchObjectGroupObjectGroupItem(requestParameter)
                .then((res) => {
                    resolve({
                        type: res.data?.type as string,
                        label: res.data?.label as string,
                        color: res.data?.color as ObjectGroupColor,
                        iconName: res.data?.iconName as IconName,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    reject();
                });
        });

    type promiseResult = {
        success: boolean;
    };
    const deleteTiersObjectGroup = (objectGroup: ObjectGroupType): Promise<promiseResult> =>
        new Promise((resolve, reject) => {
            let requestParameter: ObjectGroupApiDeleteObjectGroupObjectGroupItemRequest = {
                id: objectGroup.id.toString(),
            };
            if (xIdSociete !== null) {
                requestParameter = { xIdSociete, ...requestParameter };
            }
            objectGroupApi
                .deleteObjectGroupObjectGroupItem(requestParameter)
                .then(() => {
                    resolve({ success: true });
                })
                .catch((err) => {
                    console.log(err);
                    reject();
                });
        });

    return { searchTiersObjectGroup, editTiersObjectGroup, deleteTiersObjectGroup };
};

const useAddSocietesObjectGroup = () => {
    const { objectGroupApi } = useTiersService();
    let addObjectGroupTimeout: number | undefined;
    const xIdSociete = useSociete();

    const addObjectGroup = (
        label: string,
        color: string,
        idTiers: string | number,
    ): Promise<Array<ObjectGroupJsonldObjectgroupCreate>> =>
        new Promise((resolve, reject) => {
            clearTimeout(addObjectGroupTimeout);
            let requestParameters: ObjectGroupApiCreateObjectGroupObjectGroupCollectionRequest = {
                objectGroupJsonldObjectgroupCreate: {
                    type: 'sousClient',
                    label,
                    color,
                    iconName: 'buildings',
                    tiers: [`/tiers/tiers/${idTiers}`],
                },
            };
            if (xIdSociete !== null) {
                requestParameters = { xIdSociete, ...requestParameters };
            }

            addObjectGroupTimeout = setTimeout(() => {
                objectGroupApi
                    .createObjectGroupObjectGroupCollection(requestParameters)
                    .then((res) => {
                        resolve(res.data as Array<ObjectGroup>);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
        });

    return { addObjectGroup };
};

export { useSocietesObjectGroup, useAddSocietesObjectGroup };
